<template>
  <form @submit.prevent="handleSubmit" id="location_create_form">
    <!-- Location Name -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Location Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="name" name="name" ref="name" v-model="form.name"
        placeholder="Enter location name (e.g., Warehouse A, Floor 2)" />
    </div>

    <!-- Description -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Description</label>
      <textarea class="form-control form-control-thin" id="description" name="description" ref="description"
        v-model="form.description" placeholder="Enter location description (e.g., Main storage area, South wing)"
        rows="3"></textarea>
    </div>

    <!-- Parent Location -->
    <div class="mb-4">
      <MultiSelect v-model="form.parent_id" :multiple="false" label="Parent Location">
        <option value="">None (Top Level Location)</option>

        <option v-for="loc in Parentlocations" :key="loc.id" :value="loc.id">
          {{ loc.name }}
        </option>
      </MultiSelect>
      <small class="text-muted">Select parent location if this is a sub-location</small>
    </div>
    <!-- Address -->
    <div class="mb-4">
      <label class="form-label form-label-thin">Address</label>
      <input type="text" class="form-control form-control-thin" id="address" name="address" v-model="form.address"
        placeholder="Enter full address" />
    </div>

    <!-- Image Upload -->
    <div class="mb-4">
      <FileUploader v-model:files="form.image" :help-text="'Upload location images. Max 10 files.'" />
    </div>
    <!-- Modal Footer -->
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-sm btn-outline-secondary hover-white" @click="close">
        <i class="fa fa-times"></i> Cancel
      </button>
      <button type="submit" class="btn btn-primary py-1 px-2 text-light hover-white btn-sm form-submit-btn"
       >
       Create Location
      </button>
    </div>
  </form>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import MultiSelect from '@/components/MultiSelect.vue'
import FileUploader from '@/components/FileUploader.vue'
export default {
  name: 'CreateLocation',
  emits: ['created', 'close'],
  components: {
    MultiSelect,
    FileUploader
  },

  props: {
    Parentlocations: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
        parent_id: '',
        address: '',
        image: [],  
      },

      submitting: false
    }
  },
  methods: {
  async handleSubmit() {
  this.submitting = true

  const fd = new FormData()
  const scalars = ['name', 'description', 'address']
  scalars.forEach(key => {
    if (this.form[key] !== null && this.form[key] !== '') {
      fd.append(key, this.form[key])
    }
  })

  if (this.form.parent_id) {
    fd.append('parent_id', this.form.parent_id)
  }

  if (Array.isArray(this.form.image) && this.form.image.length) {
    this.form.image.forEach(file => {
      fd.append('image[]', file)
    })
  }

  const result = await form_api_submit({
    url: 'locations/create',
    method: 'POST',
    data: fd,
    curr_form_id: '#location_create_form'
  })

  if (result.success) {
    this.$emit('created')
    this.close()
    await this.$nextTick()
    this.resetForm()  // ← reset AFTER close, not before
  }

  this.submitting = false
},
    close() {
      this.$emit('close')
    },
resetForm() {
  this.form.name = ''
  this.form.description = ''
  this.form.parent_id = ''
  this.form.address = ''
  this.form.image = []
}
  }
}
</script>

<style scoped>
.text-muted {
  color: #6c757d;
  font-size: 0.75rem;
}
</style>